import React from 'react';
import { Modal, Descriptions, Tag } from 'antd';
import { formatApiDate } from '../../helpers/dateUtils';

const TransactionDetailModal = ({ visible, onCancel, transaction }) => {
  if (!transaction) return null;

  const getTransactionTypeColor = (type) => {
    const colors = {
      PURCHASE: 'green',
      SALE: 'blue',
      RETURN_TO_SUPPLIER: 'orange',
      RETURN_FROM_CUSTOMER: 'cyan',
      ADJUSTMENT: 'purple',
      TRANSFER: 'magenta',
      WRITE_OFF: 'red',
      COLLECTION_ADDITION: 'lime',
      COLLECTION_REMOVAL: 'volcano',
      LOCATION_TRANSFER: 'geekblue',
      STORE_RECEIPT: 'gold',
      STORE_SHIPMENT: 'default'
    };
    return colors[type] || 'default';
  };

  return (
    <Modal
      title="Transaction Details"
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={800}
    >
      <Descriptions bordered column={2}>
        <Descriptions.Item label="Transaction ID">
          {transaction.id}
        </Descriptions.Item>
        <Descriptions.Item label="Transaction Date">
          {formatApiDate(transaction.transactionDate, 'YYYY-MM-DD HH:mm:ss')}
        </Descriptions.Item>
        
        <Descriptions.Item label="Item" span={2}>
          {transaction.itemName} (ID: {transaction.itemId})
        </Descriptions.Item>
        
        <Descriptions.Item label="Transaction Type">
          <Tag color={getTransactionTypeColor(transaction.transactionType)}>
            {transaction.transactionType.replace(/_/g, ' ')}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Quantity">
          {transaction.quantity}
        </Descriptions.Item>
        
        <Descriptions.Item label="Unit Price">
          {transaction.unitPrice ? `$${transaction.unitPrice.toFixed(2)}` : '-'}
        </Descriptions.Item>
        <Descriptions.Item label="Total Price">
          {transaction.totalPrice ? `$${transaction.totalPrice.toFixed(2)}` : '-'}
        </Descriptions.Item>
        
        <Descriptions.Item label="Reference Number" span={2}>
          {transaction.referenceNumber || '-'}
        </Descriptions.Item>
        
        {(transaction.sourceStoreName || transaction.sourceStoreDepartmentName) && (
          <>
            <Descriptions.Item label="Source Location Type">
              {transaction.sourceLocationType || '-'}
            </Descriptions.Item>
            <Descriptions.Item label="Source Store">
              {transaction.sourceStoreName || '-'}
            </Descriptions.Item>
            <Descriptions.Item label="Source Department" span={2}>
              {transaction.sourceStoreDepartmentName || '-'}
            </Descriptions.Item>
          </>
        )}
        
        {(transaction.destinationStoreName || transaction.destinationStoreDepartmentName) && (
          <>
            <Descriptions.Item label="Destination Location Type">
              {transaction.destinationLocationType || '-'}
            </Descriptions.Item>
            <Descriptions.Item label="Destination Store">
              {transaction.destinationStoreName || '-'}
            </Descriptions.Item>
            <Descriptions.Item label="Destination Department" span={2}>
              {transaction.destinationStoreDepartmentName || '-'}
            </Descriptions.Item>
          </>
        )}
        
        <Descriptions.Item label="Notes" span={2}>
          {transaction.notes || '-'}
        </Descriptions.Item>
      </Descriptions>
    </Modal>
  );
};

export default TransactionDetailModal;